import {
  ADDITIONAL_PAGES_ROUTE,
  BULK_EDIT,
  EDIT_PAGE_COMPLETE_ROUTE,
  PAGE_BUILDER_ROUTE,
  WEB_EDITOR_ROUTE,
} from "@/Constants/routesConstant";
import { SETTING_PAGE_SUBROUTES } from "@/Constants/setting";
import { getFixRouteString } from "../Utils";

export const TAB_TYPE = {
  PARENT: 0,
  CHILD: 1,
};

export const PARENT_TAB_ID = {
  HOME: 0,
  CATALOG: 1,
  GROW: 2,
  UTILITY: 3,
  WEBSITE: 4,
  ECOMM: 5,
  MARKETING: 6,
  CUSTOMER: 7,
  SETTING: 8,
  SUPPORT: 9,
};

export const SUB_NAVLIST_IDS = {
  HOME: {
    ORDER: 0,
    LEADS: 1,
    STORE_ANALYTICS: 2,
    OUT_OF_STOCK: 3,
  },
  CATALOG: {
    PRODUCT: 0,
    COLLECTION: 1,
    CUSTOMER_REVIEW: 2,
    WISHLISTS: 3,
  },
  WEBSITE: {
    BUILDER: 0,
    TEMPLATES: 1,
    BLOGS: 2,
    ADDITIONAL_PAGES: 3,
    THEME_EDITOR: 4,
    SEO: 5,
  },
};

export const NAVBAR_MINIMIZER_ROUTES_PREFIX = [
  getFixRouteString(SETTING_PAGE_SUBROUTES.STORE_POLICIES),
  getFixRouteString(PAGE_BUILDER_ROUTE),
  getFixRouteString(WEB_EDITOR_ROUTE),
  getFixRouteString(BULK_EDIT),
];
